export default __webpack_public_path__ + "static/media/ic_logout.18850e4f.svg";